export default __webpack_public_path__ + "44e1495b4dbea69e68b0a36b48b63d25.svg";